import React, { useState, useEffect, useRef, useCallback } from 'react';
import Bacon from '../ingredients/Bacon';
import Egg from '../ingredients/Egg';
import Crouton from '../ingredients/Crouton';
import Chicken from '../ingredients/Chicken';
import Cheese from '../ingredients/Cheese';
import Lettuce from '../ingredients/Lettuce';

import recipeImg from '../../assets/images/recipes/caesarSalad.png';
import './pages/levelTemplate.css';
import frying_pan from "../../assets/images/cookware/pan.svg";
import spatula from "../../assets/images/cursors/spatula.svg";
import tongs from "../../assets/images/cursors/tongs.svg";
import LevelTemplate from './levelTemplate';

const Level8 = () => {
  // Define the recipe for this level
  const recipe = {
    name: 'Caesar Salad',
    image: recipeImg,
  };

  // Define the required ingredients for this level
  const requiredIngredients = {
    Bacon: { count: 4, 
      component: <Bacon />, 
      cookingArea: 'FryingPan1', 
      intervals: [6, 3, 4], 
      timed: true 
    },
    Crouton: { count: 12, 
        component: <Crouton />, 
        cookingArea: 'FryingPan2', 
        intervals: [3, 2, 3], 
        timed: true 
      },
      Egg: { count: 2, 
        component: <Egg />, 
        cookingArea: 'FryingPan2', 
        intervals: [4, 4, 3], 
        timed: true 
      },
      Chicken: { count: 4, 
        component: <Chicken />, 
        cookingArea: 'FryingPan1', 
        intervals: [9, 4, 4], 
        timed: true 
      },
      Cheese: { count: 2, 
        component: <Cheese />, 
        cookingArea: 'CuttingBoard', 
        intervals: null,
        timed: false
      },
      Lettuce: { count: 6, 
        component: <Lettuce />, 
        cookingArea: 'CuttingBoard', 
        intervals: null,
        timed: false
      },
      
  };

  const requiredCookware = {
    FryingPan1: {
      cookwareKey: 'FryingPan1',
      image: frying_pan,
      size: 250, 
      targetZone: 'Stove',
      objectLimit: 4, 
      innerOffsets: [50, 30],
      outerOffsets: [-60, -10],
      initialObjects: [],
      cursor: tongs,
    },
    FryingPan2: {
        cookwareKey: 'FryingPan2',
        image: frying_pan,
        size: 250, 
        targetZone: 'Stove',
        objectLimit: 4, 
        innerOffsets: [50, 30],
        outerOffsets: [180, -80], 
        initialObjects: [],
        cursor: spatula,
      }
  }

  // Use the LevelTemplate component with the defined props
  return (
    <LevelTemplate
      levelNumber={8}
      recipe={recipe}
      timeLimit={45} // Time limit in seconds
      requiredIngredients={requiredIngredients}
      requiredCookware={requiredCookware}
    />
  );
};

export default Level8;
